<template>
  <div>
    <template v-if="registerFlag">
      <Register @submitHandler="registerHandler" @checkHandle="checkHandle"></Register>
    </template>
    <template v-else>
      <Login @submitHandler="loginHandler" @checkHandle="checkHandle"></Login>
    </template>
  </div>
</template>

<script>
import Register from './account-register'
import Login from './account-login'

export default {
  components: {
    Register,
    Login,
  },
  data() {
    return {
      registerFlag: false,
    }
  },
  methods: {
    checkHandle(val) {
      this.registerFlag = val;
    },
    loginHandler(data) {
      this.$emit('accountLogin', data)
    },
    registerHandler(data) {
      this.$emit('accountRegister', data)
    }
  },
}
</script>

<style lang="scss" scoped>
@import '@css/var.scss';

.mobileInputBox {
  padding: 30px 20px;
}

.el-form-item--small.el-form-item {
  margin-bottom: 40px;
}

.info {
  padding-top: 10px;
}

.login-input {
  border-bottom: 1px solid #e0e4e6;

  ::v-deep {
    .el-input__inner {
      background: transparent;
      border: none;
      border-radius: 0;
      padding: 0;
    }

    .el-input-group__append {
      border: none;
      background: transparent;

      .btn-yzm {
        padding: 9px 0;
      }
    }
  }
}

.btn-login {
  width: 100%;
  font-size: 16px;
  padding: 15px;
}
</style>
